import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

export default function useDefaultPathname(defaultPathname) {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    const { hash} = window.location;

    let newpathname;
    if (pathname === "/") {   // do a catch here. modify the default pathname
      newpathname = defaultPathname;
    } else {
      newpathname = pathname;
    }
    // if (!hash.includes(defaultPathname)) {
    if (!hash.includes(newpathname)) {
      history.replace({
        ...location,
        // pathname: defaultPathname,
        pathname: newpathname,        //need to repair the #
      });
    }
  }, [defaultPathname, history, location]);
}
